module.exports = __webpack_public_path__ + "images/giftTree/wedding.81193cd4ea4c5c95a57cd33d84c1454a.png";